{
  "namingTriad": {
    "security": "No-Forged-Compliance-Under-Structural-Inexpressibility",
    "governance": "Auditable Compliance Without Witness Disclosure",
    "mathematical": "Zero-Knowledge Compliance Proofs"
  },
  "conjectures": [
    {
      "id": "ZKP-1",
      "label": "Propositional Truncation Compliance Predicate",
      "status": "PROVED",
      "statement": "IsCompliant_T x = ∥ W(T, x) ∥ — the weakest predicate sufficient for compliance is the propositional truncation: some witness exists, none privileged.",
      "agdaName": "zkp-1-theorem",
      "agdaFile": "agda/Research/ZeroKnowledgeCompliance/ComplianceZKP.agda",
      "conditional": null
    },
    {
      "id": "ZKP-2",
      "label": "PERMIT Encoding Faithfulness",
      "status": "PROVED",
      "statement": "∥ SliceMorphism A X ∥ ↔ ∥ DAGPath authority-dag X A ∥ — a ZKP witness for DAG reachability is a valid witness for the slice morphism.",
      "agdaName": "zkp2-canonical",
      "agdaFile": "agda/Research/ZeroKnowledgeCompliance/CanonicalAuthorityDAG.agda",
      "conditional": "Proved for the canonical authority DAG (edges = Hom). Open sub-goal PO-ZKP-2-external: isomorphism to an externally-defined DAG."
    },
    {
      "id": "ZKP-3",
      "label": "Structural Soundness Strengthening",
      "status": "PROVED",
      "statement": "¬ IsCompliant_T x → ¬ ∃ π · ZKP-Verifies (encode T x) π. A non-compliant prover cannot produce an accepting transcript — the proof object literally does not exist, with probability bound 0 by construction.",
      "agdaName": "zkp3-all-canonical-systems",
      "agdaFile": "agda/Research/ZeroKnowledgeCompliance/GeneratorSoundness.agda",
      "conditional": "One universal proof covers all four generator classes (G1/G2/G3/G4). PO-ZKP-3-external is a circuit-formalization gap, not a theorem gap."
    },
    {
      "id": "ZKP-4",
      "label": "ZKP Compositionality via COMPOSE",
      "status": "PROVED",
      "statement": "zkp-compose : ZKPProof(M₁) → ZKPProof(M₂) → ComposeWitness M₁ M₂ M → ZKPProof(M). Component proofs compose into a composite proof via the COMPOSE operad — no recomposition barrier.",
      "agdaName": "zkp-compose",
      "agdaFile": "agda/Research/ZeroKnowledgeCompliance/ComplianceZKP.agda",
      "conditional": null
    },
    {
      "id": "ZKP-5",
      "label": "SNF Four-Phase Circuit Canonicity",
      "status": "PROVED",
      "statement": "Any full-compliance ZKP circuit factors through the canonical B1→B2→B3→B4 four-phase structure (seam normal form) — no shorter full-compliance circuit exists.",
      "agdaName": "zkp5-complete-proof",
      "agdaFile": "agda/Research/ZeroKnowledgeCompliance/CircuitCanonicity.agda",
      "conditional": "Proved via SNF-TERMINAL (RD-24). Open sub-goal PO-ZKP-5-minimality: three-phase bridge to the GovFact category."
    },
    {
      "id": "ZKP-6",
      "label": "Generator-Circuit Decomposition Completeness",
      "status": "PROVED",
      "statement": "The four sub-circuits {G1, G2, G3, G4} are a complete and non-redundant decomposition of the full compliance circuit — exactly four, no fewer, no more.",
      "agdaName": "zkp6-proof",
      "agdaFile": "agda/Research/ZeroKnowledgeCompliance/GeneratorCircuitDecomposition.agda",
      "conditional": null
    }
  ]
}
